// Built-in animated gradient "scenes" shown until the user connects photos. Pure CSS, so
// there are no external requests and nothing to license.

export interface AmbientScene {
  name: string;
  layers: string[]; // CSS background layers, top first
}

export const AMBIENT_SCENES: AmbientScene[] = [
  {
    name: 'Northern Lights',
    layers: [
      'radial-gradient(ellipse 80% 50% at 30% 20%, rgb(52 211 153 / 0.55), transparent 70%)',
      'radial-gradient(ellipse 60% 40% at 70% 30%, rgb(129 140 248 / 0.45), transparent 70%)',
      'linear-gradient(180deg, #020617 0%, #0f172a 60%, #1e293b 100%)',
    ],
  },
  {
    name: 'Desert Dusk',
    layers: [
      'radial-gradient(circle at 70% 75%, rgb(253 186 116 / 0.8), transparent 40%)',
      'linear-gradient(180deg, #312e81 0%, #9d174d 45%, #f97316 80%, #fbbf24 100%)',
    ],
  },
  {
    name: 'Ocean Calm',
    layers: [
      'radial-gradient(ellipse 120% 60% at 50% 110%, rgb(14 165 233 / 0.7), transparent 70%)',
      'linear-gradient(180deg, #082f49 0%, #0c4a6e 50%, #155e75 100%)',
    ],
  },
  {
    name: 'Forest Morning',
    layers: [
      'radial-gradient(circle at 20% 15%, rgb(254 240 138 / 0.5), transparent 35%)',
      'linear-gradient(170deg, #14532d 0%, #166534 40%, #3f6212 75%, #1a2e05 100%)',
    ],
  },
  {
    name: 'Lavender Fields',
    layers: [
      'radial-gradient(ellipse 90% 50% at 50% 0%, rgb(244 114 182 / 0.45), transparent 70%)',
      'linear-gradient(180deg, #4c1d95 0%, #7c3aed 50%, #c4b5fd 100%)',
    ],
  },
];
